/**
 * Tables JS controller.
 */

import Indicate from 'indicate';

/**
 * Class Accordion
 */
class Tables {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.tables = document.querySelectorAll( '.tablepress' );
    }

    /**
     * Initialize table functionalities.
     */
    initTables() {
        if ( this.tables.length ) {
            const indicate = new Indicate( this.tables );

            // Make tables focusable for scrolling with keyboard.
            for ( const table of indicate.targetElements ) {
                table.setAttribute( 'tabIndex', 0 );
            }
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.initTables();
    }
}

// Export the class reference.
module.exports = Tables;



// WEBPACK FOOTER //
// ./assets/scripts/tables.js